import React from 'react';

export const user = {name: 'System Administrator'};

export const UserContext = React.createContext(null);